import { UseMultipleChartsType } from '@ecosystem/export-utils';
import { FC, useMemo, useState } from 'react';
import { MultiChartExportContext, MultiLineChartExportType } from './MultiChartExportContext';

interface MultiLineChartExportProviderProps {
  children: React.ReactNode;
}

const MultiChartExportProvider: FC<MultiLineChartExportProviderProps> = ({ children }) => {
  const [multipleExportCallbacks, setMultipleExportCallbacks] = useState<UseMultipleChartsType>([]);
  const [chartRefLoadedState, setChartRefLoadedState] = useState<boolean[]>([]);

  const contextValue: MultiLineChartExportType = useMemo(
    () => ({
      multipleExportCallbacks,
      setMultipleExportCallbacks,
      chartRefLoadedState,
      setChartRefLoadedState,
    }),
    [multipleExportCallbacks, chartRefLoadedState],
  );

  return <MultiChartExportContext.Provider value={contextValue}>{children}</MultiChartExportContext.Provider>;
};

export default MultiChartExportProvider;
